import { Box } from "@mui/material";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import ShCopyButton from "../../../theme/ShCopy";
import { ORDER_FILTER_KEYS } from "../../DataGrid/Filter";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import SHQuickAction from "../../../theme/Modal/SHQuickAction";
import ShLabel from "../../../theme/label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";
import OrdersCard from "../../cards/orders/OrdersCard";
import { HighlightedColumn } from "./HighlightedColumn";
import RhOrdersCard from "./cards/RhOrdersCard";

export const orderColumns =  (i18n,theme,t,colors,columnStrategy) => {
    
    return [
        // {
        //     field: "barcode",
        //     headerName: t('order'),
        //     flex:1,
        //     renderCell: (params) => {
        //         console.log(params);
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return (
        //             <Box sx={{
        //                 minWidth:"100%",
        //                 height:"100%",
        //                 display:"flex",
        //                 alignItems:"center",
        //                 position:"relative",
        //                 whiteSpace:"nowrap",
        //                 wordBreak:"keep-all",
        //                 textOverflow:"ellipsis",
        //                 overflow:"hidden",
        //                 ".copyel": {
        //                     opacity:0,
        //                 },
        //                 "&:hover .copyel": {
        //                     opacity:1,
        //                 }
        //             }}>
        //                 <Text noBreak>{params.row.barcode}</Text>
        //                 <ShCopyButton
        //                     styles={{button:{
        //                         background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
        //                         color: colors.txt["primary"],
        //                         "&:hover" : {
        //                             background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

        //                         }
        //                     }}} 
        //                     sx={{position:"absolute",right:0,zIndex:3000}} 
        //                     className={"copyel"} 
        //                     closeAfter={1500} 
        //                     value={params.row.barcode}
        //                 ></ShCopyButton>
        //             </Box>
        //         );
        //     }
        // },
        // {field: "deliveryName", headerName: t("name"),flex:1, 
        //     renderCell: (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.deliveryName
        //     }
        // },
        {field: "relation", 
            headerName: t("relation"),
            flex:1,
            // filter: ORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{params.row.relation?.name}</Text>)
            }
        },
        {field: "webshopreference", 
            headerName: t("webshopreference"),
            flex:1,
            // filter: ORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        // {
        //     field: "date_planned", 
        //     headerName: t("date_planned_shipment"),
        //     flex:1,
        //     shFilter: {
        //         type: "date"
        //     },
        //     renderCell: (params) => {

        //         if(params.row.skeleton) {
        //             return <ShLabelSkeleton/>
        //         }

        //         let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
        //         let planned = new Date(params.row.date_planned);
        //         let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
        //         let latestHandoverDateTime = params.row.latestHandoverDateTime ? new Date(params.row.latestHandoverDateTime) : null;

        //         if(sent) {
        //             // when sent is filled and is equal to planned: green
        //             if(sent.getTime() === planned.getTime()) {
        //                 labelcolor = "green";
        //             }
        //             // when sent is filled but later than planned: orange
        //             else if(sent.getTime() > planned.getTime()) {
        //                 labelcolor = "orange";
        //             }
        //         }
        //         else {
        //             // When sent is not filled and planned >= now: blue
        //             if(planned.setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) {
        //                 labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
        //             } else if(latestHandoverDateTime && (new Date().setHours(0,0,0,0) < latestHandoverDateTime)) {
        //                 labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
        //             // When sent is not filled and planned < now: red
        //             } else if(planned.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
        //                 labelcolor = "red";
        //             }
        //         }
                
        //         return (
        //             <SHQuickAction
        //                 component={ params.row.latestHandoverDateTime !== null ?
        //                     <Box
        //                         sx={{
        //                             px:1.5,
        //                             display:"flex",
        //                             flexDirection:"column"
        //                         }}
        //                     >
        //                         <Text light>{t("handover_date")}</Text>
        //                         <Text>
        //                             { new Date(params.row.latestHandoverDateTime).toLocaleDateString(i18n.language)}&nbsp;
        //                             <b>
        //                             {new Date(params.row.latestHandoverDateTime).toLocaleTimeString(i18n.language, {
        //                                 hour: '2-digit',
        //                                 minute: '2-digit'
        //                             })}
        //                             </b>
        //                         </Text>
        //                     </Box>
        //                     : 
        //                     null
        //                 }
        //             >
        //                 {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
        //                     <Box
        //                         aria-owns={anchorEl ? 'simple-popover' : undefined}
        //                         aria-haspopup={false}
        //                         onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
        //                         onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
        //                         onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
        //                         sx={{
        //                             width:1,
        //                         }}
        //                     >
        //                         <ShLabel clickable size={32} fitted variant={labelcolor} palette="normal">
        //                             {!sent && planned.toLocaleDateString(i18n.language)}
        //                             {sent && sent.toLocaleDateString(i18n.language)}
        //                         </ShLabel>
        //                     </Box>
        //                 )}
        //             </SHQuickAction>
        //         );
        //     }
        // },
        // {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1,
        //     sortable:false,
        // renderCell: (params) => {
        //     if(params.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }
        //     return params.row.amountOfLines
        // }},
        {
            field: "stream", 
            headerName: t("stream"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STREAM,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(columnStrategy !== null) {
                    if(columnStrategy.key === "stream" || columnStrategy.key === "streams") {
                        const strat = columnStrategy.series.find(item => item.name === params.row.stream?.name);
                        if(strat) {
                            return (
                                <HighlightedColumn
                                    theme={theme}
                                    value={params.row.stream?.name}
                                    strat={strat}
                                />
                            )
                        }
                    }
                }
                return params.row.stream?.name
            }
        },
        {
            field: "shipper", 
            headerName: t("shipper_name"),
            flex:1,

            filter: ORDER_FILTER_KEYS.SHIPPER,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(columnStrategy !== null) {
                    if(columnStrategy.key === "shipper") {
                        const strat = columnStrategy.series.find(item => item.name === params.row.shipper?.name);
                        if(strat) {
                            return (
                                <HighlightedColumn
                                    theme={theme}
                                    value={params.row.shipper?.name}
                                    strat={strat}
                                />
                            )
                        }
                    }
                }
                return `${params.row.shipper?.name ?? ""}`
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                const { labelcolor, labeltext } = getOrderStateData(params.row.state, theme, false, params.row.snoozeWhenAvailable);
                
                return (
                        <Box
                            sx={{
                                width:1,
                            }}
                        >
                            <ShLabel clickable size={32} palette="normal" variant={labelcolor}>
                                {t(labeltext)}
                            </ShLabel>
                        </Box>
                    );
                }
        },
        {
            field: "createdAt", 
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <span>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </span>
                );
                }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RhOrdersCard
                        // selectable={params.row.state === general_states.OPEN}
                        // select={handleCardSelection} 
                        // selected={selectedItems.includes(params.row.id)} 
                        // onClick={() => getOrderDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row}  
                    />
                )
            }
        }
    ]
};